import { render } from "./PushBatchesInformation.vue?vue&type=template&id=5473f95e&scoped=true"
import script from "./PushBatchesInformation.vue?vue&type=script&lang=js"
export * from "./PushBatchesInformation.vue?vue&type=script&lang=js"

import "./PushBatchesInformation.vue?vue&type=style&index=0&id=5473f95e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5473f95e"]])

export default __exports__